__turbopack_context__.v({
  "active": "MobileTabs-module-scss-module__3k2zDG__active" + " " + "MobileTabs-module-scss-module__3k2zDG__link",
  "content": "MobileTabs-module-scss-module__3k2zDG__content",
  "flex": "MobileTabs-module-scss-module__3k2zDG__flex",
  "link": "MobileTabs-module-scss-module__3k2zDG__link",
  "root": "MobileTabs-module-scss-module__3k2zDG__root",
});
